import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Stack, Typography } from "@mui/material";

// project import
import { OutlineButton } from "components/buttons/OutlineButton";

const CountdownOverlay = ({ timeLeft, handleCancel }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255,255,255,0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "10px",
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          width: "320px",
          bgcolor: "common.white",
          p: 4,
          borderRadius: "12px",
          boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
          textAlign: "center",
        }}
      >
        <Stack spacing={3} alignItems='center'>
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#172664",
            }}
          >
            Proceeding in...
          </Typography>

          <Typography
            sx={{
              fontSize: "80px",
              fontWeight: "bold",
              lineHeight: 1,
              color: "#172664",
            }}
          >
            {timeLeft}s
          </Typography>

          <OutlineButton
            onClick={handleCancel}
            width='160px'
            height='36px'
            sx={{
              borderRadius: "20px",
              borderColor: "#172664",
              color: "#172664",
            }}
          >
            Cancel
          </OutlineButton>
        </Stack>
      </Box>
    </Box>
  );
};

export default CountdownOverlay;
